export default "__VITE_ASSET__0eiioBRS__"